exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__disclaimerAlert___mMiZ3 {\n  text-align: left;\n  margin-bottom: 17px; }\n  @media (max-width: 576px) {\n    .styles__disclaimerAlert___mMiZ3 {\n      margin-left: 10px;\n      margin-right: 10px; } }\n", ""]);

// exports
exports.locals = {
	"disclaimerAlert": "styles__disclaimerAlert___mMiZ3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SearchPage/AdsSection/styles.scss
// module id = 4276
// module chunks = 6